// extracted by mini-css-extract-plugin
module.exports = {"loader":"AppLoader_loader__328DX"};